import { MetadatiProtocolloVO } from "./metadati-protocolloVO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { FascicoloVO } from "./fascicoloVO";
import { SettoreVO } from "./settoreVO";
import { ClassificaVO } from "./classificaVO";
import { TipologiaDocumentoVO } from "./tipologia-documentoVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { TempiConservazioneVO } from "./tempi-conservazioneVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";

export class FiltroRicercaUnitaDocumentariaVO {
  oggetto: string;

  fascicoloAppartenenza: FascicoloVO;

  voceClassifica: ClassificaVO;

  metadatiProtocollo: MetadatiProtocolloVO;

  dataProtocolloDal: string;

  dataProtocolloAl: string;

  dataAnniInserimentoFascicoloDal: string;

  dataAnniInserimentoFascicoloAl: string;

  dataAnniInserimentoSistemaDal: string;

  dataAnniInserimentoSistemaAl: string;

  dataAnniModificaDal: string;

  dataAnniModificaAl: string;

  dataAnniChiusuraDal: string;

  dataAnniChiusuraAl: string;

  dataAnniArchiviazioneDal: string;

  dataAnniArchiviazioneAl: string;

  inseritoDa: string;

  inseritoDaCf: string;

  stato: string;

  codiceClassificazione: string;

  codiceStrutturaCmu: string;

  strutturaResponsabile: SettoreVO;

  tempiConservazione: TempiConservazioneVO;

  numeroRepertorio: number;

  dataAnniRepertoriazioneDal: string;

  dataAnniRepertoriazioneAl: string;

  tipologiaDocumento: TipologiaDocumentoVO;

  campiSpecifici: CampoSpecificoFascicoloVO[];

  campiSpecificiTipologia: CampoSpecificoFascicolazioneVO[];

  nomeFile: string;

  statoDaEscludere: string;

  idRepository: string;

  hash: string;

  tipo: TipoSupportoDocumentoEnum;

  limitazioniVisibilitaUtente: boolean;

  ricercaSemplice: string;

  descrizioneFile: string;

  firmatario: string;

  autore: string;

  dataManuale: string;

  collocazioneFisica: string;

  originale: string;
}
